<div class="position-relative">
<ion-datetime [(ngModel)]="time" presentation="time" locale="en-US"></ion-datetime>
<span>:</span>
</div>
<div class="bottom-actions">
    <ion-button  expand="block" fill="clear" (click)="cancel()">Cancel</ion-button>
    |
    <ion-button  expand="block" fill="clear" (click)="close()">Set</ion-button>
</div>